import { Actions } from './form-postprocessors.actions'
import { fromJS } from 'immutable'
import * as FormPostprocessorsTypes from './form-postprocessors.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  create: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  update: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function formPostprocessorsReducer(
  state = initialState,
  action: Actions,
) {
  switch (action.type) {
    case FormPostprocessorsTypes.UPDATE_FORM_POSTPROCESSOR_REQUEST: {
      return state.setIn(['update', 'isLoading'], true)
    }

    case FormPostprocessorsTypes.UPDATE_FORM_POSTPROCESSOR_SUCCESS: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case FormPostprocessorsTypes.UPDATE_FORM_POSTPROCESSOR_FAILURE: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case FormPostprocessorsTypes.CREATE_FORM_POSTPROCESSOR_REQUEST: {
      return state.setIn(['create', 'isLoading'], true)
    }

    case FormPostprocessorsTypes.CREATE_FORM_POSTPROCESSOR_SUCCESS: {
      return state.setIn(['create', 'isLoading'], false)
    }

    case FormPostprocessorsTypes.CREATE_FORM_POSTPROCESSOR_FAILURE: {
      return state.setIn(['create', 'isLoading'], false)
    }

    case FormPostprocessorsTypes.DELETE_FORM_POSTPROCESSOR_REQUEST: {
      return state
    }

    case FormPostprocessorsTypes.DELETE_FORM_POSTPROCESSOR_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case FormPostprocessorsTypes.DELETE_FORM_POSTPROCESSOR_FAILURE: {
      return state
    }

    case FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSORS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSORS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSORS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSOR_REQUEST: {
      return state.setIn(['update', 'isLoading'], true)
    }

    case FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSOR_SUCCESS: {
      return state
        .setIn(['update', 'isLoading'], false)
        .setIn(['update', 'data'], fromJS(action.payload).delete('id'))
    }

    case FormPostprocessorsTypes.FETCH_FORM_POSTPROCESSOR_FAILURE: {
      return state.setIn(['update', 'isLoading'], false)
    }

    case FormPostprocessorsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case FormPostprocessorsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
